import React, { useEffect, useState } from 'react';
import './navbar.css';
import Logout from '../Logout/Logout';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import { AppBar, Toolbar, Typography, Box, IconButton, FormControl, Select, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext'; 
import Brightness4Icon from "@mui/icons-material/Brightness4"; // Icon for dark mode
import WbSunnyIcon from "@mui/icons-material/WbSunny"; // Icon for light mode
import SettingsIcon from "@mui/icons-material/Settings"; // Icon for system mode

const Navbar = ({ isLoggedIn, setIsLoggedIn, onToggleSidebar }) => {
  const navigate = useNavigate();
  const { toggleTheme } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(localStorage.getItem("theme") || "system");
  const [anchorEl, setAnchorEl] = useState(null);

  // Funkcija za automatsko određivanje sistemske teme
  const getSystemTheme = () => (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

  // Funkcija za promenu teme na osnovu korisničkog odabira
  const handleThemeChange = (newTheme) => {
    setSelectedTheme(newTheme);
    setAnchorEl(null); // Zatvori meni nakon izbora
  };

  useEffect(() => {
    const themeToApply = selectedTheme === "system" ? getSystemTheme() : selectedTheme;
    toggleTheme(themeToApply); // Primeni promenu teme u aplikaciji
    localStorage.setItem("theme", selectedTheme); // Sačuvaj izbor u localStorage
  }, [selectedTheme, toggleTheme]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Otvori meni
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Zatvori meni
  };

  const renderSelectedIcon = () => {
    if (selectedTheme === "system") {
      const systemTheme = getSystemTheme();
      return systemTheme === "dark" ? <Brightness4Icon /> : <WbSunnyIcon />;
    }
    return selectedTheme === "dark" ? <Brightness4Icon /> : <WbSunnyIcon />;
  };

  return (
    <AppBar position="fixed">
      <Toolbar className="navbar-container">
        <Box display="flex" alignItems="center">
          <IconButton color="inherit" edge="start" onClick={onToggleSidebar} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            className="navbar-title"
            onClick={() => navigate("/home")}
          >
            TnA
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          {/* IconButton za promenu teme */}
          <IconButton
            color="inherit"
            onClick={handleMenuOpen}
            sx={{ marginLeft: 2 }}
          >
            {renderSelectedIcon()}
          </IconButton>
          {/* Menu sa opcijama za teme */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleThemeChange("light")}>
              <WbSunnyIcon sx={{ marginRight: 1 }} />
              Light
            </MenuItem>
            <MenuItem onClick={() => handleThemeChange("dark")}>
              <Brightness4Icon sx={{ marginRight: 1 }} />
              Dark
            </MenuItem>
            <MenuItem onClick={() => handleThemeChange("system")}>
              <SettingsIcon sx={{ marginRight: 1 }} />
              System
            </MenuItem>
          </Menu>
          <LanguageSwitch />
          <Logout isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
